import React, { createContext, useCallback, useContext, useState } from 'react';

interface ProductComparisonContextProps {
  selected: number;
  select(value: number): () => void;
  changeSelected(value: number): void;
}

export const ProductComparisonContext = createContext<ProductComparisonContextProps | null>(null);

interface SelectionProviderProps {
  children: React.ReactElement | React.ReactElement[];
}

export const ProductComparisonContextProvider: React.FC<SelectionProviderProps> = ({ children }) => {
  const [selected, setSelected] = useState<number>(0);

  const select = useCallback(
    (value: number) => () => {
      setSelected(value);
    },
    []
  );

  const changeSelected = useCallback((value: number) => {
    setSelected(value);
  }, []);

  return (
    <ProductComparisonContext.Provider value={{ selected, select, changeSelected }}>
      {children}
    </ProductComparisonContext.Provider>
  );
};

export const useProductComparisonContext = (): ProductComparisonContextProps => {
  const context = useContext(ProductComparisonContext);

  if (!context) {
    throw Error(
      'The `useProductComparisonContext` hook must be called from a descendent of the `ProductComparisonProvider`.'
    );
  }

  return context;
};
